export default __webpack_public_path__ + "6b542313b840c7d503be60c2add300d3.png";